import { DashboardSpeed } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const SpeedIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <DashboardSpeed width={size} height={size} color={color} {...rest} />;

SpeedIcon.displayName = 'SpeedIcon';

export default SpeedIcon;
